import React, { useState } from "react";

const API_URL = "https://vionstech.com/apis/contact_form_submissions_api.php";

const ContactSection = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    website: "", // honeypot
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ loading: false, ok: null, msg: "" });

  const onChange = (e) => {
    const { id, name, value } = e.target;
    setForm((f) => ({ ...f, [id || name]: value }));
  };

  const validate = () => {
    const e = {};
    if (!form.name || form.name.trim().length < 2) e.name = "Min 2 characters.";
    if (!form.email || !/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Enter a valid email.";
    if (!form.message || form.message.trim().length < 5) e.message = "Min 5 characters.";
    if (form.phone && !/^[0-9+\-() .]{6,20}$/.test(form.phone)) e.phone = "Invalid phone format.";
    if (form.subject && form.subject.length > 200) e.subject = "Max 200 characters.";
    return e;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: false, ok: null, msg: "" });

    const v = validate();
    setErrors(v);
    if (Object.keys(v).length) return;

    try {
      setStatus({ loading: true, ok: null, msg: "" });

      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        if (res.status === 422 && data?.errors) {
          setErrors(data.errors);
          setStatus({ loading: false, ok: false, msg: "Please fix the highlighted fields." });
        } else {
          setStatus({ loading: false, ok: false, msg: data?.error || "Something went wrong." });
        }
        return;
      }

      setStatus({ loading: false, ok: true, msg: data?.message || "Message sent!" });
      setForm({ name: "", email: "", phone: "", subject: "", message: "", website: "" });
      setErrors({});
    } catch {
      setStatus({ loading: false, ok: false, msg: "Network error. Please try again." });
    }
  };

  return (
    <section id="contact" className="py-5" style={{ background: "var(--canvas)" }}>
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5 section-header">
          <span
            className="badge rounded-pill px-3 py-2 mb-2"
            style={{
              background: "var(--chip)",
              color: "var(--chiptext)",
              border: "1px solid var(--cardborder)",
            }}
          >
            Get In Touch
          </span>
          <h2 className="display-5 fw-bold mb-3" style={{ color: "var(--secondarytext)" }}>
            Contact Us
          </h2>
          <div className="divider mx-auto mb-4"></div>
          <p className="mt-3 lead" style={{ color: "var(--secondarytext)", opacity: 0.8 }}>
            Get in touch to learn more about our products and services
          </p>
        </div>

        <div className="row g-5">
          {/* Contact Info */}
          <div className="col-12 col-md-5">
            <div className="contact-info">
              <h3 className="mb-4" style={{ color: "var(--secondarytext)" }}>Get in touch</h3>

              <div className="contact-item d-flex align-items-start mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 me-3"
                  style={{
                    width: 50,
                    height: 50,
                    background: "var(--chip)",
                    color: "var(--primary)",
                    flexShrink: 0
                  }}
                >
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div>
                  <h5 style={{ color: "var(--secondarytext)" }}>Address</h5>
                  <p style={{ color: "var(--secondarytext)", opacity: 0.8, margin: 0 }}>
                    Ground Floor IndiQube Opal Indiqube Double Road, No. 192 and 193, Binnamangala, 2nd Stage, 100 ft. Road, Indiranagar, Bangalore- 560038
                  </p>
                </div>
              </div>

              <div className="contact-item d-flex align-items-start mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 me-3"
                  style={{
                    width: 50,
                    height: 50,
                    background: "var(--chip)",
                    color: "var(--primary)",
                    flexShrink: 0
                  }}
                >
                  <i className="fas fa-phone"></i>
                </div>
                <div>
                  <h5 style={{ color: "var(--secondarytext)" }}>Phone</h5>
                  <p style={{ color: "var(--secondarytext)", opacity: 0.8, margin: 0 }}>
                    +91 8676038528
                  </p>
                </div>
              </div>

              <div className="contact-item d-flex align-items-start mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 me-3"
                  style={{
                    width: 50,
                    height: 50,
                    background: "var(--chip)",
                    color: "var(--primary)",
                    flexShrink: 0
                  }}
                >
                  <i className="fas fa-envelope"></i>
                </div>
                <div>
                  <h5 style={{ color: "var(--secondarytext)" }}>Email</h5>
                  <p style={{ color: "var(--secondarytext)", opacity: 0.8, margin: 0 }}>
                    connect@vionstech.com
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-12 col-md-7">
            <div
              className="card border-0 p-4 h-100"
              style={{ 
                background: "var(--card)", 
                border: "1px solid var(--cardborder)",
                borderRadius: "16px"
              }}
            >
              <form onSubmit={onSubmit} noValidate>
                {/* Honeypot */}
                <input
                  type="text"
                  name="website"
                  value={form.website}
                  onChange={onChange}
                  autoComplete="off"
                  style={{ display: "none" }}
                  tabIndex={-1}
                />

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="name" className="form-label" style={{ color: "var(--secondarytext)", fontWeight: 500 }}>
                      Your Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={form.name}
                      onChange={onChange}
                      style={{
                        backgroundColor: "var(--card)",
                        borderColor: errors.name ? "var(--error)" : "var(--cardborder)",
                        color: "var(--secondarytext)",
                        borderRadius: "8px",
                        padding: "12px 16px"
                      }}
                    />
                    {errors.name && (
                      <small className="error mt-1 d-block" style={{ color: "var(--error)" }}>
                        {errors.name}
                      </small>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="email" className="form-label" style={{ color: "var(--secondarytext)", fontWeight: 500 }}>
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={onChange}
                      style={{
                        backgroundColor: "var(--card)",
                        borderColor: errors.email ? "var(--error)" : "var(--cardborder)",
                        color: "var(--secondarytext)",
                        borderRadius: "8px",
                        padding: "12px 16px"
                      }}
                    />
                    {errors.email && (
                      <small className="error mt-1 d-block" style={{ color: "var(--error)" }}>
                        {errors.email}
                      </small>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="phone" className="form-label" style={{ color: "var(--secondarytext)", fontWeight: 500 }}>
                      Phone (optional)
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      name="phone"
                      value={form.phone}
                      onChange={onChange}
                      style={{
                        backgroundColor: "var(--card)",
                        borderColor: errors.phone ? "var(--error)" : "var(--cardborder)",
                        color: "var(--secondarytext)",
                        borderRadius: "8px",
                        padding: "12px 16px"
                      }}
                    />
                    {errors.phone && (
                      <small className="error mt-1 d-block" style={{ color: "var(--error)" }}>
                        {errors.phone}
                      </small>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="subject" className="form-label" style={{ color: "var(--secondarytext)", fontWeight: 500 }}>
                      Subject (optional)
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      name="subject"
                      value={form.subject}
                      onChange={onChange}
                      style={{
                        backgroundColor: "var(--card)",
                        borderColor: errors.subject ? "var(--error)" : "var(--cardborder)",
                        color: "var(--secondarytext)",
                        borderRadius: "8px",
                        padding: "12px 16px"
                      }}
                    />
                    {errors.subject && (
                      <small className="error mt-1 d-block" style={{ color: "var(--error)" }}>
                        {errors.subject}
                      </small>
                    )}
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="message" className="form-label" style={{ color: "var(--secondarytext)", fontWeight: 500 }}>
                    Your Message
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    rows="4"
                    value={form.message}
                    onChange={onChange}
                    style={{
                      backgroundColor: "var(--card)",
                      borderColor: errors.message ? "var(--error)" : "var(--cardborder)",
                      color: "var(--secondarytext)",
                      borderRadius: "8px",
                      padding: "12px 16px"
                    }}
                  />
                  {errors.message && (
                    <small className="error mt-1 d-block" style={{ color: "var(--error)" }}>
                      {errors.message}
                    </small>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn w-100 py-3"
                  disabled={status.loading}
                  style={{
                    backgroundColor: status.loading ? "var(--cardborder)" : "var(--primary)",
                    color: "white",
                    borderRadius: "8px",
                    border: "none",
                    fontWeight: 600,
                    transition: "all 0.3s ease"
                  }}
                  onMouseOver={(e) => {
                    if (!status.loading) {
                      e.target.style.backgroundColor = "var(--primary-dark)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!status.loading) {
                      e.target.style.backgroundColor = "var(--primary)";
                    }
                  }}
                >
                  {status.loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Sending...
                    </>
                  ) : (
                    "Send Message"
                  )}
                </button>

                {status.msg && (
                  <div
                    className={`mt-3 p-3 text-center rounded`}
                    style={{
                      backgroundColor: status.ok ? "var(--chipalt)" : "rgba(242, 90, 90, 0.1)",
                      color: status.ok ? "var(--success)" : "var(--error)",
                      fontWeight: 500
                    }}
                  >
                    {status.msg}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;